export function datasetLabelArr(ds_str: string) {
  if (!ds_str) return ["", ""];
  else if (is_file(ds_str))
    return ["", "file", ds_str]; //return ["file", "..." + ds_str.slice(-15)];
  else if (ds_str.includes(".")) {
    const splt = ds_str.split(".");
    const l = splt.length;
    if (l === 2) return ["", splt.slice(0, l - 1).join("."), splt[l - 1]];
    else return [splt.slice(0, l - 2).join("."), splt[l - 2], splt[l - 1]];
  } else return ["", "", ds_str];
}

export function datasetLabel(ds_str: string) {
  const arr = datasetLabelArr(ds_str);
  //if (arr[0] === "" && arr[1] === "") return "";
  if (arr[1] === "file") return arr[2];
  else return arr.filter((c) => c.length > 0).join(".");
}

/**
 * Checks if a dataset name represents a file path by testing if it:
 * - Starts with common file system prefixes (file:, hdfs:, abfss:, s3:, s3a:, gs:)
 * - OR starts with a forward slash (/)
 * Case insensitive matching is used
 */
function is_file(ds_name: string): boolean {
  // Match if string starts with one of the file system prefixes followed by a colon and/or slash
  ds_name = ds_name.toLowerCase();
  return (
    ds_name.includes(":/") || ds_name.startsWith("/") || ds_name.startsWith("group:")
  );
}
